var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCost = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_661)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.72727 3.63636C8.72727 3.23471 8.40167 2.90909 8 2.90909C7.59833 2.90909 7.27273 3.23471 7.27273 3.63636V4.0622C6.24637 4.29961 5.45455 5.19143 5.45455 6.29876C5.45455 7.40087 6.25084 8.32124 7.31949 8.54567L8.33207 8.75833C8.79527 8.85564 9.09091 9.23753 9.09091 9.6408C9.09091 10.1127 8.68371 10.5455 8.11825 10.5455H8C7.47193 10.5455 7.05564 10.2007 6.94153 9.77527C6.83753 9.38735 6.43872 9.15716 6.05076 9.26116C5.66281 9.36516 5.43262 9.764 5.53663 10.152C5.76376 10.9991 6.4323 11.6541 7.27273 11.8973V12.3636C7.27273 12.7653 7.59833 13.0909 8 13.0909C8.40167 13.0909 8.72727 12.7653 8.72727 12.3636V11.9245C9.75775 11.6643 10.5455 10.7593 10.5455 9.6408C10.5455 8.51025 9.72858 7.56531 8.63098 7.33484L7.6184 7.12218C7.18407 7.03098 6.90909 6.6736 6.90909 6.29876C6.90909 5.86021 7.28807 5.45455 7.81876 5.45455H8C8.52807 5.45455 8.94436 5.79933 9.05847 6.2247C9.16247 6.61265 9.56131 6.84284 9.94924 6.73884C10.3372 6.63484 10.5673 6.23599 10.4633 5.84803C10.2362 5.00087 9.56771 4.34592 8.72727 4.10269V3.63636Z",
    fill: "#090E2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCost);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cost.2bedfca760f201fbc244decf69863c69.svg";